import logo from './logo.svg';
import './App.css';
import { goto_addJoke, goto_generator, addJoke } from './nav.js';
import { db, generateJoke } from './firebase.js';
import { collection, query, addDoc, doc, setDoc } from 'firebase/firestore';

function App() {
  const q = query(collection(db,'jokes'));

  function addJoke(){
    console.log("Adding your joke...");

    const newJokeInput = document.getElementById("newJokeInput");
    var input = newJokeInput.value;
    console.log(input);

    addDoc(collection(db,'jokes'),{
      joke:input
    })

    window.alert("Your joke has been added!");
    console.log("Done!");
  };

  return (
    <div className="App">
      <div id = "joke-container">
        <h1>dad joke generator</h1>
        <h1>------------------</h1>
        <p id = "generated-joke">why did the football coach go to the bank? <br/>to get his quarter back!</p>
        <button id = "new-joke-btn" onClick = { generateJoke }>generate joke </button>
        <button id = "add-joke-btn" onClick = { goto_addJoke }>+ add a joke</button>
      </div>

      <div id = "add-joke-container">
        <h1>add a joke :)</h1>
        <h1>------------------</h1>
        <textarea placeholder = "say something funny..." id = "newJokeInput"></textarea>
        <button id = "create-joke-btn" onClick = { addJoke }>add my joke </button>
        <button id = "back-btn" onClick = { goto_generator }><i className = "fa fa-angle-double-left"></i> back to generator</button>
      </div>
    </div>
  );
}

export default App;
